import VersionDisplay from "./VersionDisplay";
import {MDBFooter} from "mdb-react-ui-kit";
import React, {useState} from "react";

export default function Footer() {
    //Impressum/Datenschutz PopUp im Login Screen
	const [, setLegalState] = useState("");

    return <MDBFooter className='text-center text-lg-start text-muted'>
				<div className='text-center p-2 d-flex gap-2 justify-content-center' id='footer-container'>
					&copy; {new Date().getFullYear()} Copyright DLR
					{/**
					<a className='text-light' href='https://www.konect.dev/'>
						konect.dev
					</a>*/}
					<img src="./images/dlrlogo.png" alt="DLR Logo" style={{width: "2em", filter: "invert(1)"}}></img>|
					<div onClick={() => { setLegalState("legalNotice") }}>Legal Notice</div>|
					<div onClick={() => { setLegalState("privacyStatement") }}>Privacy Statement</div>|
					<VersionDisplay/>
				</div>
			</MDBFooter>
}